export const colorFromName = (name: string) => {
  name = name.replaceAll(" ","")
  switch (name) {
    case "AshlynMarshall":
      return "#D53572";
    case "HannahMaiorino":
      return "#6464ED";
    case "LaToyaShabazz":
      return "#1577E7";
    case "BethanyWilder":
      return "#EAB248";
    case "CharityMoya":
        return "#7FC361";
    case "ErickaMurphy":
      return "#EF7C36";
    case "KristineSantos":
      return "#285501";
    case "":
      return "#000000";
    default:
      let hash = 0;
      for (let i = 0; i < name?.length; i++) {
        hash = name?.charCodeAt(i) + ((hash << 5) - hash);
      }
      let color = "#";
      for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 0xff;
        color += ("00" + value.toString(16)).slice(-2);
      }
      return color;
  }
};
